import React, { useState } from 'react';
import {
  Refresh as RefreshIcon,
  PersonAdd as PersonAddIcon,
  MailOutline as MailOutlineIcon,
  MoreVert as MoreVertIcon,
  AdminPanelSettings as PermissionsIcon,
  FileDownload as FileDownloadIcon,
} from '@mui/icons-material';
import './EmployeeManagementBottomNav.css';

export default function EmployeeManagementBottomNav({
  onRefresh,
  isRefreshing,
  onInvite,
  canInvite,
  onPendingInvites,
  onPermissions,
  canOpenPermissions,
  onExport,
  canExport,
}) {
  const [moreOpen, setMoreOpen] = useState(false);

  const closeMore = () => setMoreOpen(false);

  return (
    <>
      <nav className="mobile-employees-bottom-nav" aria-label="Employee management actions">
        <button type="button" onClick={onRefresh} aria-label="Refresh team list">
          <RefreshIcon
            style={{
              animation: isRefreshing ? 'employee-mobile-nav-spin 1s linear infinite' : 'none',
            }}
          />
          <span>Refresh</span>
        </button>
        <button type="button" onClick={onInvite} disabled={!canInvite} aria-label="Invite employee">
          <PersonAddIcon />
          <span>Invite</span>
        </button>
        <button
          type="button"
          onClick={onPermissions}
          disabled={!canOpenPermissions}
          aria-label="Permissions"
        >
          <PermissionsIcon />
          <span>Permissions</span>
        </button>
        <button
          type="button"
          onClick={() => setMoreOpen((o) => !o)}
          aria-expanded={moreOpen}
          aria-label="More actions"
        >
          <MoreVertIcon />
          <span>More</span>
        </button>
      </nav>

      {moreOpen && (
        <>
          <div className="mobile-employees-more-backdrop" onClick={closeMore} aria-hidden />
          <div className="mobile-employees-more-menu" role="menu">
            <button
              type="button"
              role="menuitem"
              className="mobile-employees-more-menu-item"
              onClick={() => {
                onPendingInvites();
                closeMore();
              }}
            >
              <MailOutlineIcon fontSize="small" />
              <span>Pending invites</span>
            </button>
            <button
              type="button"
              role="menuitem"
              className="mobile-employees-more-menu-item"
              onClick={() => {
                onExport();
                closeMore();
              }}
              disabled={!canExport}
            >
              <FileDownloadIcon fontSize="small" />
              <span>Export</span>
            </button>
          </div>
        </>
      )}
    </>
  );
}
